import { render, staticRenderFns } from "./WrkSubAgentView.vue?vue&type=template&id=dda2af50&scoped=true"
import script from "./WrkSubAgentView.vue?vue&type=script&lang=js"
export * from "./WrkSubAgentView.vue?vue&type=script&lang=js"
import style0 from "./WrkSubAgentView.vue?vue&type=style&index=0&id=dda2af50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda2af50",
  null
  
)

export default component.exports